export default __webpack_public_path__ + "static/media/linkedin.5dc7b40b.svg";